import { FLAG_FILTER_TAB_OPTIONS } from '../shared/constants/flags'
import { AdminCategoryOption, AdminErrorOption, AdminOption, AdminSubCategoryOption } from './adminOptions'
import { DocumentChunk } from './documentChunk'

export enum FlagEnum {
    TASK = 'task',
    NOTE = 'note',
    CFB = 'cfb',
}

export interface JiraStatus {
    id: number
    jirastatusname: string
}

export interface NewOpeningLink {
    opening_id: number | null
    coordinates: [number, number]
    document_chunk_id: DocumentChunk['id']
}

export interface OpeningLink extends NewOpeningLink {
    id: number
}

export interface OpeningLinkWithFlagId extends OpeningLink {
    flag_id: number
    order: number
    type: string | null
    status: number | null
    jiraStatusId: JiraStatus['id'] | null
}

export interface FlagOption {
    id: number
    name: string
    is_active: boolean
}

export interface FlagOptions {
    types: AdminOption[]
    statuses: AdminOption[]
    severities: AdminOption[]
    categories: AdminCategoryOption[]
    requirementSources: AdminOption[]
    subCategories: AdminSubCategoryOption[]
    intakeMethods: AdminOption[]
    errors: AdminErrorOption[]
}

export interface BaseFlag {
    id: number
    project_id: number
    created_by_user_email: string
    created_by_username: string
    description: string
    document_chunk_id: number
    opening_links: OpeningLink[]
    order: number
}

export interface NormalizedFlag extends BaseFlag {
    order: number
    type?: FlagOption | null
    status?: FlagOption | null
    severity?: FlagOption | null
    category?: FlagOption | null
    error?: FlagOption | null
    requirement_source?: FlagOption | null
    sub_category?: FlagOption | null
    created_at: string | null
    updated_at?: string | null
    intake_method?: FlagOption | null
    submitter_name?: string | null
    reply_count: number
    creationJiraStatus: JiraStatus | null
    creation_jira_status_name?: string | null
}

export interface FlagFormData {
    description: string
    type_id: number
    created_by_username: string
    created_by_user_email: string
    status_id?: number | null
    category_id?: number | null
    error_id?: number | null
    requirement_source_id?: number | null
    sub_category_id?: number | null
    severity_id?: number | null
    submitter_name?: string | null
    requirement_source?: number | null
}

export interface FlagAPIPayload extends FlagFormData {
    opening_links: NewOpeningLink[]
}

export interface FlagAPIUpdatePayload {
    status_id?: number
    category_id?: number
    requirement_source?: number
    sub_category_id?: number
    description?: string
    error_id?: number | null
}

export interface FlagAPIResponse extends BaseFlag {
    category_id?: number | null
    requirement_source_id?: number | null
    severity_id?: number | null
    status_id?: number | null
    sub_category_id?: number | null
    type_id?: number | null
    created_at: string | null
    intake_method_id?: number | null
    submitter_name?: string | null
    updated_at?: string | null
    reply_count: number
    creationJiraStatus: JiraStatus | null
    creation_jira_status_name?: string | null
    error_id?: number | null
}

export interface FlagCommentsAPICreatePayload {
    comment: string
    flagID: number
    createdByUserEmail: string
}

export interface FlagComments {
    comment: string
    created_at: string
    created_by_user_email: string
    flag_id: number
    id: string
    updated_at: string
}

export interface FlagOpeningLinksAPIUpdatePayload {
    id: number
    flag_id: number
    coordinates: [number, number]
    opening_id?: number
}

export interface FlagAxiosAPIResponse {
    updatedFlag: FlagAPIResponse
}

export interface FlagFilters {
    tab: FLAG_FILTER_TAB_OPTIONS
    status: number[]
    jiraStatuses: number[]
}

export type PendingFlagSwitch = {
    flagId: number
    paperId?: number
} | null
